import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
  Avatar,
  Box,
  IconButton,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "@apollo/client";
import { UPDATE_EMPLOYEE } from "../../../../../../apis/organization-apis/people-apis/peopleApis";
import moment from "moment";
import ConfirmSnackbar from "../../../../../../components/Snackbar/ConfirmSnackbar";
import ConfirmDialog from "../../../../../../components/ConfirmDialog/ConfirmDialog";
import DatePicker from "../../../../../../components/DatePicker/DatePicker";

function OffboardDialog({
  open,
  onClose,
  staffMember,
  refetch,
  closeDetailDialog,
}) {
  const [updateEmployee, { loading }] = useMutation(UPDATE_EMPLOYEE);
  const [lastWorkingDate, setLastWorkingDate] = useState("");
  const [snackbarInfo, setSnackbarInfo] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const TransitionComponent = (props) => {
    return <Slide {...props} direction="left" />;
  };

  const handleOffBoard = async () => {
    const variables = {
      employeeId: staffMember?.employeeId,
      employmentStatus: "Inactive",
      terminationDate: moment(lastWorkingDate).format("YYYY-MM-DD"),
    };

    try {
      const response = await updateEmployee({ variables });
      refetch();
      onClose();
      closeDetailDialog();
      setLastWorkingDate("");
      setIsOpen(false);
      setSnackbarInfo({
        message: response?.data?.updateEmployee?.message,
        vertical: "top",
        horizontal: "right",
        Transition: TransitionComponent,
      });
    } catch (error) { }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        sx={{ "& .MuiDialog-paper": { maxWidth: "540px" } }}
      >
        <DialogTitle fontWeight="bold">
          Offboard Staff Member
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {/* <Box display="flex" alignItems="center" mb={2}>
          <Avatar sx={{ bgcolor: "primary.main", mr: 2 }}>CW</Avatar>
          <Box>
            <Typography variant="h5">Christopher Wilson</Typography>
            <Typography variant="body2" color="text.secondary">
              christopher.wilson@regodit.xyz
            </Typography>
          </Box>
        </Box> */}
          <Box display="flex" alignItems="center" my={2}>
            <Typography
              color="text.secondary"
              variant="body2"
              sx={{ flexBasis: "30%" }}
            >
              Staff Name:
            </Typography>
            <Box display="flex" alignItems="center" sx={{ flex: 1 }}>
              <Avatar sx={{ bgcolor: "primary.main" }}>
                {staffMember?.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </Avatar>
              <Typography variant="h5">{staffMember?.name}</Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" my={2}>
            <Typography
              color="text.secondary"
              variant="body2"
              sx={{ flexBasis: "30%" }}
            >
              Email:
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              <strong>{staffMember?.email}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" my={2}>
            <Typography
              color="text.secondary"
              variant="body2"
              sx={{ flexBasis: "30%" }}
            >
              Date of Joining:
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              <strong>
                {staffMember?.joinDate || "Date of joining missing"}
              </strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" my={2}>
            <Typography
              color="text.secondary"
              variant="body2"
              sx={{ flexBasis: "30%" }}
            >
              Employment Type:
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              <strong>{staffMember?.type}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" my={2}>
            <Typography
              color="text.secondary"
              variant="body2"
              sx={{ flexBasis: "30%" }}
            >
              Source of Info:
            </Typography>
            <Typography variant="body2" sx={{ flex: 1 }}>
              <strong>Regodit</strong>
            </Typography>
          </Box>

          <Typography
            variant="body2"
            gutterBottom
            color="#1F1F1F"
            fontSize="16px"
            my={3}
          >
            If the staff member is not part of the organization anymore, then
            offboard them by choosing the last working date.
          </Typography>
          <Box>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
              Last Working Date
            </Typography>
            <DatePicker
              fullWidth
              value={lastWorkingDate}
              onChange={(date) => setLastWorkingDate(date)}
              required
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => setIsOpen(true)}
            variant="contained"
            color="primary"
            disabled={!lastWorkingDate}
          >
            Off-Board
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onConfirm={handleOffBoard}
        heading="Confirm Off-Boarding"
        content={`Are you sure you want to Off-Board ${staffMember?.name}`}
        buttonText="Yes Off-Board"
        loading={loading}
      />
      <ConfirmSnackbar snackbarInfo={snackbarInfo} />
    </>
  );
}

export default OffboardDialog;
